import { t } from '../../../common/i18n.js'
import type { Language } from '../../../common/types/i18n.js'
import './portal-task-pill.css'

// Small app-styled pills for the Notion Tasklist's Status and Priority columns.
// Status values are open-ended Notion option names; we map known ones to colors
// via a normalized slug class and fall back to a neutral pill for anything else.

const slugify = (value: string): string =>
    value
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')

export const StatusPill = ({ status }: { status: string | null }) => {
    if (!status) return null
    return (
        <span className={`portal-task-pill portal-task-pill--s-${slugify(status)}`}>{status}</span>
    )
}

export type TaskPriority = 'High' | 'Medium' | 'Low'

const priorityLabel: Record<TaskPriority, (lang: Language) => string> = {
    High: t.common.priority.high,
    Medium: t.common.priority.medium,
    Low: t.common.priority.low,
}

export const PriorityPill = ({
    priority,
    lang,
}: {
    priority: TaskPriority | null
    lang: Language
}) => {
    if (!priority) return null
    return (
        <span className={`portal-task-pill portal-task-pill--p-${priority.toLowerCase()}`}>
            {priorityLabel[priority](lang)}
        </span>
    )
}
